// SpecRef: ARCH-005, TMDXNC-238
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#9-schema-level-empty-data-detection
// The ARCH-005 §9 empty-array `v.check` is deliberately ABSENT here (TMDXNC-238).
// It assumed newCases is never legitimately empty; in practice NOP routinely
// returns zero new cases and every such poll raised a false-positive
// "backend may be unavailable or data is stale" warning on the board. Zero new
// cases is a real state, so it validates clean. `activeCases` and `surgeons`
// keep their checks. Empty-response telemetry still flows via ARCH-005 §10
// (`logEmptyResponseToSentry`), which is independent of this schema.
import * as v from 'valibot';

import { newCaseSchema } from '#entities';

export const newCasesResponseSchema = v.object({
  /** Array of new cases; may legitimately be empty (TMDXNC-238). */
  data: v.array(newCaseSchema),
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type NewCasesResponse = v.InferInput<typeof newCasesResponseSchema>;
